document.addEventListener('DOMContentLoaded', function () {

    // Base URL extraction, split url into array and create shallow copy
    const baseUrl = window.location.pathname.split('/').slice(0,3).join('/');

    // get tags for pages with filtered URL
    const currentTags = window.location.pathname.split('/')[3]?.split('+') || [];
    
    // pre-select checkboxes for filtered URLs

    document.querySelectorAll('.filter-radio-nics').forEach(inputBox => {
        if(currentTags.includes(inputBox.value)){
            inputBox.checked = true;
        }
    });
    
    document.querySelectorAll('.filter-radio-nics').forEach(inputBox => {
        // on selection, we gather checkboxes information
        inputBox.addEventListener('change', () => {
            const selectedTags = [];

            const nameGroups = ['brand-type', 'transfer-type', 'connector-type', 'interface-gen', 'quantity-type', 'format-type'];

            nameGroups.forEach(group  => {
                const selected = document.querySelector(`input[name=${group}]:checked`);

                if(selected && selected.checked){
                    selectedTags.push(selected.value);
                }
            });

            const newUrl = selectedTags.length > 0 ? `${baseUrl}/${selectedTags.join('+')}`: baseUrl;
            
            window.location.href = newUrl;

        });

    });

    let clearButton = document.getElementById('clearFilter');
    clearButton.addEventListener('click', () => {
        if(window.location.pathname !== baseUrl){
            window.location.href = baseUrl;
        }else{
            clearButton.setAttribute('disabled', '');
        }
    });

});


// Sorting logic 
document.getElementById('sort_by').addEventListener('change', function() {
    let selectedOption = this.value;
    // Build the new URL with the selected sorting option
    let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname  + selectedOption;
    window.location.href = newUrl; // Redirect to the new URL
});


// Logic for Q&A boxes 

let btnOpen = document.querySelectorAll('.question');


btnOpen.forEach(btn => {
    btn.addEventListener('click', () => {
        let questionBox = btn.closest('.q-list');
        let answer = questionBox.querySelector('.answer');
        let divider = questionBox.querySelector('.solid');
        let icon =  btn.querySelector('#btn-open');

        if(answer.style.display === 'none' && divider.style.display === 'none'){
            answer.style.display = 'block'
            divider.style.display = 'block';
            questionBox.style.background = 'white';
            divider.style.border = '1px solid #0080008c';
            questionBox.style.border = '3px solid green';
            icon.style.background = 'white';
            icon.style.transition = 'transform 1s ease-in';
            icon.style.transform = 'rotate(180deg)';
        }else {

            answer.style.display = 'none'
            divider.style.display = 'none';
            icon.style.transition = 'transform 1s ease-in';
            icon.style.transform = 'rotate(0deg)';
            icon.style.background = 'rgb(237, 237, 237)';
            questionBox.style.background = 'rgb(237, 237, 237)';
            questionBox.style.border = '1px solid gray';

        }


    });
});

const filterOverlay = document.getElementById('filterOverlay');

document.querySelector('.filter-btn').addEventListener('click', () => {
    if(document.querySelector('.filtering-section').style.display === 'none') {
        document.querySelector('.filtering-section').style.display = 'block';
        document.querySelector('.filter-btn').innerText = 'Close Filter'
         filterOverlay.classList.add('active');
    }else {
        document.querySelector('.filtering-section').style.display = 'none';
        document.querySelector('.filter-btn').innerText = 'Filter'
        // Hide filter and overlay when overlay is clicked
        filterOverlay.addEventListener('click', () => {
            filterOverlay.classList.remove('active');
            document.querySelector('.filtering-section').style.display = 'none';
            document.querySelector('.filter-btn').innerText = 'Filter'
        });
    }
});